
// Range slider input (used for Donations)
(function($) { "use strict";

	//Wait until everything is loaded
	window.addEventListener("load", function(){

		//force show the form if the user just submitted it. it contains either a success or a error message.
		const current_url_string = (window.location.href);
		const current_url = new URL(current_url_string);
		const current_form_position = current_url.searchParams.get("mail_form");

		//if the user submitted the overlay, force open it on load to show the response
		if (current_form_position === 'overlay') {
			$('.mailing-list-overlay').removeClass('js-hidden');
			//set cookie to not automatically open the overlay again
			setCookie('mail_overlay_dismissed', true, 10 * 365 /* 10 years */);
		}

		//if the user submitted the footer form, scroll to it on load to show the response
		if (current_form_position === 'footer') {
			$("footer form.dotMailer_news_letter")[0].scrollIntoView({
				behavior: "instant", // "smooth" or "auto" or "instant"
				block: "start" // "start" or "end"
			});
		}

		//show overlay after 30 sec if it hasn't been dismissed before (and if it hasn't been just submitted. see above)
		const overlay_dismissed = getCookie('mail_overlay_dismissed');
		if (!overlay_dismissed) {
			setTimeout(function(){
				$('.mailing-list-overlay').removeClass('js-hidden');
			}, 20000 /*20 seconds*/);
		}

		//manage overlay dismissal
		$('.mailing-list-overlay .close-button').on('click', function(){
			//hide overlay
			$('.mailing-list-overlay').addClass('js-hidden');

			//set cookie to not automatically open the overlay again
			setCookie('mail_overlay_dismissed', true, 10 * 365 /* 10 years */);
		});

		//fix input elements in javascript - the plugin is limited on this
		$("form.dotMailer_news_letter input").each(function(index, element) {

			const element_id = $(element).attr("id");
			const label = $(element).closest("form").find("label[for="+element_id+"]");

			//if the element has a label, the label content is put into the element's placeholder and the label is removed
			if (element_id && label.length) {
				let placeholder = $(label).text();
				placeholder = placeholder.replace('Your email address*:', 'Email*'); //fix placeholder content for email
				$(element).attr("placeholder", placeholder);
				$(label).remove();
			}

			//set the email input from type="text" to type="email" for automatic validation
			$('form.dotMailer_news_letter input.email').attr('type', 'email');

			//set elements as required
			$(element).prop('required',true);
		});

		//Convert footer submit to icon style button
		$('.block-mailing-list input[name="dm_submit_btn"]').addClass('js-submit-button').attr("value", "");

		//FORM manipulation:
		$("form.dotMailer_news_letter").each(function(){
			const $form = $(this);

			//add a querystring parameter to form action to know if it is from the popup or the footer
			let form_position = null;
			if ($form.closest('.mailing-list-overlay').length) { form_position = 'overlay'; }
			if ($form.closest('footer').length) { form_position = 'footer'; }
			$form.attr('action', '?mail_form=' + form_position);

			//move the checkbox inside the form
			$form
				.closest('.js-mailing-list-form-container')
				.find('.confirm-newsletter-signup')
				.detach()
				.insertAfter($form.find('input[type=submit]'))
			;
		})

	});

})(jQuery);

